import $ from 'jquery'

export class UnitPreferenceService {
  constructor() {
    this.csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
  }

  async save(unit) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: '/session/measuring_unit_preference',
        type: 'POST',
        data: JSON.stringify({ unit }),
        contentType: 'application/json; charset=utf-8',
        headers: { 'X-CSRF-Token': this.csrfToken },
        success: () => resolve(),
        error: (xhr, status, error) => reject(new Error(`Failed to save unit preference: ${error}`))
      })
    })
  }
}
